<template>
	<div>
		<div
			class="innerBox"
			style="
				display: flex;
				flex-direction: row;
				align-items: center;
				padding: 7.5px 10px;
			"
		>
			<button
				class="btn"
				style="
					font-size: 16px;
					color: #6c6c6c;
					font-weight: bold;
					padding: 4px;
				"
				@click="$router.go(-1)"
			>
				<i class="fas fa-angle-left mr-2"></i>Back
			</button>
			<p
				class="mb-0"
				style="font-size: 16px; color: #b9b9b9; font-weight: 600"
			>
				| NOS <i class="fas fa-angle-right"></i>
			</p>
			<p
				class="mb-0 ml-1"
				style="font-size: 16px; color: #4b4b4b; font-weight: bold"
			>
				Edit NOS
			</p>
		</div>

		<!-- Your content goes here -->
		<form>
			<div class="innerBox col mt-4">
				<h2 style="font-size: 24px font-weight: bolder;">
					New Criteria
				</h2>

				<div class="row mt-3 f-25">
					<div class="col-3">
						<label style="font-size: 22px">Pilih Ekspedisi</label>
					</div>
					<div class="col-4">
						<div class="search-container">
							<div class="dropdown-container">
								<multiselect
									v-model="form.ekspedisi_id"
                                    :custom-label="labelEkspedisi"
									:options="ekspedisiOptions.map(x => x.id)"
									placeholder="Select Ekspedisi"
								></multiselect>
							</div>
						</div>
					</div>
				</div>

                <div class="row mt-3 f-25">
					<div class="col-3">
						<label style="font-size: 22px">Pilih Criteria</label>
					</div>
					<div class="col-4">
						<div class="search-container">
							<div class="dropdown-container">
								<!-- {{ nosOptions }} -->
								<multiselect
									v-model="form.nos_id"
                                    :custom-label="labelNos"
									:options="nosOptions.map(x => x.id)"
									placeholder="Select NOS"
								></multiselect>
							</div>
						</div>
					</div>
				</div>

                <div class="filter row mt-3">
                    <div class="col-lg-2 col-md-6">
                    </div>
                    <div class="col-lg-2 col-md-6">
                    </div>
                    <div class="col-lg-2 col-md-6">
                    </div>
                    <div class="col-lg-2 col-md-6">
                    </div>
                    <div class="col-lg-2 col-md-6">
                    </div>
                    <div class="col-lg-2 col-md-6">
                    <button 
                    type="button" 
                    class="btn w-100 btn-primary" 
                    style="font-size:100%; "
                    @click="submitForm()">Simpan</button>
                    </div>
                </div>

			</div>
		</form>
	</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Multiselect from "vue-multiselect";

export default {
	metaInfo: {
		title: "Edit NOS",
	},
	data() {
		let startDate = moment().startOf("month").format("YYYY-MM-DD");
		let currentDate = moment().format("YYYY-MM-DD");

		return {
			ekspedisiOptions: [],
            selectedNos: null, // To store the selected "nos" value
            nosOptions: [],    // To store the options retrieved from the API
			phoneNoError: false,
			selectedNopol: null,
			filter: {
				start: startDate,
				end: currentDate,
			},
			form: {
				ekspedisi_id : null,
				nos_id : null

			},
		};
	},
	components: {
		Multiselect,
	},
	created() {
		// Fetch data from the API
		axios
			.get("/api/master/ekspedisi")
			.then((response) => {
				if (response.data && response.data.data) {
					// Map the API data to match the format expected by vue-multiselect
					this.ekspedisiOptions = response.data.data;
				}
			})
			.catch((error) => {
				console.error("Error fetching ekspedisi data:", error);
			});

        axios
            .get("/api/master/nos")
            .then((response) => {
                if (response.data && response.data.data) {
                // Map the API data to match the format expected by vue-multiselect
                this.nosOptions = response.data.data;
                }
            })
            .catch((error) => {
                console.error("Error fetching ekspedisi data:", error);
            });
	},
    mounted() {
        if (this.$store.state.nosData) this.getData();
    },
	watch: {
		"form.name"() {
			this.form.name = this.form.name.toUpperCase();
		},
	},
	methods: {
        labelEkspedisi(data) {
            return Object.keys(data).length > 0 ? data.name : (this.ekspedisiOptions.find(x => x.id === data) ? this.ekspedisiOptions.find(x => x.id === data).name : data.name);
        },
        labelNos(data) {
            return Object.keys(data).length > 0 ? data.nos : (this.nosOptions.find(x => x.id === data) ? this.nosOptions.find(x => x.id === data).nos : data.nos)
        },
        getData() {
            const parseData = JSON.parse(this.$store.state.nosData);
            this.form.ekspedisi_id = Number(parseData.id);
            this.form.nos_id = Number(parseData.nos_id);
        },
		restrictToNumbers() {
			// Limit the input to 12 characters or less
			if (this.form.phone_no.length > 12) {
				this.form.phone_no = this.form.phone_no.slice(0, 12);
			}
			if (this.form.name.length > 50) {
				this.form.name = this.form.name.slice(0, 50);
			}

			// Remove any non-numeric characters from the input
			this.form.phone_no = this.form.phone_no.replace(/[^0-9]/g, "");
			this.form.ekspedisi = this.form.ekspedisi.replace(/[^0-9]/g, "");
			this.form.ktp_no = this.form.ktp_no.replace(/[^0-9]/g, "");
			this.form.license_no = this.form.license_no.replace(/[^0-9]/g, "");
		},
		restrictToAlphaNumeric() {
			// Get the current input value
			let inputValue = this.form.license_no;

			// Use a regular expression to remove any characters that are not alphanumeric
			inputValue = inputValue.replace(/[^a-zA-Z0-9]/g, "");

			// Update the input value with the cleaned value
			this.form.license_no = inputValue;
		},
		goBack() {
			this.$router.go(-1); // Go back to the previous route
		},
		submitForm() {
			this.$swal
				.fire({
					title: "Konfirmasi Approval",
					text: "Apakah NOS yang Anda buat sudah sesuai?",
					icon: "warning",
					showCancelButton: true,
					confirmButtonColor: "#3085D6",
					cancelButtonColor: "#D33",
					confirmButtonText: "Post NOS",
				})
				.then((result) => {
					if (result.value) {
						// Only send the 'id' of the selected ekspedisi
						const requestData = {
							nos : [
								this.form
							]
						}

						this.$http
							.put("/api/nos-ekspedisi/audit", requestData)
							.then(() => {
								this.$swal.fire({
									title: "Success!",
									icon: "success",
									type: "success",
									text: "Edit NOS berhasil disimpan",
								});
								this.$router.go(-1); // Go back to the previous route
							})
							.catch((error) => {
								console.error(
									"%cerror DashboardUserUM.vue line:78 ",
									"color: red; display: block; width: 100%;",
									error
								);
								this.$swal.fire({
									title: "Error!",
									icon: "error",
									type: "error",
									text: error.response.data.message,
								});
							});
					}
				});
		},
	},
};
</script>

<style scoped>
.innerBox {
	background-color: white;
	border-radius: 8px;
	box-shadow: 0px 3px 10px #0000000f;
	padding: 20px;
	padding-left: 40px;
}

.chart {
	background-color: white;
	border-radius: 8px;
	box-shadow: 0px 3px 10px #0000000f;
	padding: 20px;
	align-items: center;
}

.elegant--sub-title {
	font-size: 18px;
	font-weight: 500;
	color: #4d4d4d;
}

/* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

.stats--icon {
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
}

.table td,
.table th {
	text-align: center;
}

.news-image-1 img {
	max-width: 100%; /* To make the image smaller and responsive */
}

.news-title-1 {
	text-align: left; /* To position the news-title on the top right */
}

.news-content-1 {
	text-align: left; /* To position the news-content on the bottom right */
}

.search-container {
	display: flex;
	align-items: center;
}

.dropdown-container {
	flex: 1;
	margin-right: 10px;
}

.searchbar-container {
	flex: 2;
}

.dropdown {
	width: 100%;
}

.searchbar {
	width: 50%;
	padding: 5px;
}
</style>
